exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.slider[data-v-91a145cc] {\n    max-height: 1000px; /* approximate max height */\n\n    transition-property: all;\n    transition-duration: .2s;\n    transition-timing-function: cubic-bezier(0, 1, 0.2, 1);\n}\n.oyh[data-v-91a145cc]{\n    overflow-y: hidden;\n}\n.slider.closed[data-v-91a145cc] {\n    max-height: 0;\n}\n", ""]);

// exports
